import { render, staticRenderFns } from "./DataTableNonVS.vue?vue&type=template&id=17f6cd0e&scoped=true"
import script from "./DataTableNonVS.vue?vue&type=script&lang=js"
export * from "./DataTableNonVS.vue?vue&type=script&lang=js"
import style0 from "./DataTableNonVS.vue?vue&type=style&index=0&id=17f6cd0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f6cd0e",
  null
  
)

export default component.exports